import Animation from './animation'

/*
 * This animation is used when we have multiple series displayed and a
 * breakdown is applied. The serie's new points start evenly stacked within
 * the previous bar's dimensions and then are moved to their new location,
 * creating a shuffle-look animation.
 */
class AddBreakdownShuffleAnimation extends Animation {

  constructor (options) {
    super(options)
    this.ripple = true
    this.delayFactor = .6
    this.reverseTransition = true
  }

  match (serie) {
    return !this.seriesChanged &&
           this.chart.previous.layout.breakdown.calculated && // Previously calculated
           !this.chart.layout.breakdown.calculated  // Now we're not calculated
  }

  animate (serie, entering, selection, merged, exiting) {
    // By definition of this animation, we know there's one exiting node
    // since we're adding a breakdown. This means the node is expanding into a bunch of other nodes
    let dim = this._getDimensions(exiting.selection())
      , scale = this.scalers.x.groupScale.copy()
                                      .padding(0)
                                      .range([Math.max(0, dim.height) + dim.y, dim.y])

    // We evenly space the new bars within the exiting bar, based on their position
    // on the x-axis. From a data perspective it makes more sense to stack based on value,
    // but the evenly spaced results in much cleaner animations
    entering.append('rect')
            .attr('x', dim.x)
            .attr('width', dim.width)
            .attr('y', (d, i) => scale(d.rangeId) - (i === entering.size() - 1 ? 0 : 1))
            .attr('height', (d, i) => scale.bandwidth() + (i === entering.size() - 1 ? 0 : 1))

    exiting.selection().remove()

    merged.duration(this.timing.duration)
          .delay(this.timing.delay)
          .tween('decorations', this.tweeners.decorations)
          .tween('all', this.tweeners.all)
  }

}

export default AddBreakdownShuffleAnimation
